import { render, staticRenderFns } from "./CRTKView.vue?vue&type=template&id=92060248&"
import script from "./CRTKView.vue?vue&type=script&lang=js&"
export * from "./CRTKView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports